<template>
  <div class="booking-list dt-page">
    <div class="top-bar">
      <div class="normal-filters">
        <div class="add-button">
          <img
            @click="onAddBookingClicked"
            class="dt-icon"
            src="static/buttons/add.svg"
            alt
          />
        </div>
        <div class="month-navigation">
          <img
            @click="previousMonthClick"
            class="dt-icon v5 s1"
            src="static/icons/arrows/chevron-left.svg"
            alt
          />
          <!-- <button class="dt-button icon left-button">
          </button>-->
          <img
            @click="nextMonthClick"
            class="dt-icon v5 s1"
            src="static/icons/arrows/chevron-right.svg"
            alt
          />
        </div>
        <Dropdown
          :options="monthsTV"
          v-if="monthsTV && monthsTV.length > 0"
          :selected="
            monthsTV.find((e) => e.value == filter.selectedMonths.value)
          "
          :placeholder="$t('show_all_bookings')"
          deselect
          :deselectLabel="$t('show_all_bookings')"
          v-on:selectedChange="(e) => onDropdownChange('month', e)"
          :listHeight="400"
          :style="{ maxWidth: '160px', width: '160px !important', flex: '6' }"
        ></Dropdown>
        <Dropdown
          :options="artistsTV"
          v-if="artistsTV && artistsTV.length > 0"
          :selected="
            artistsTV.find(
              (e) =>
                e.value ==
                (filter.selectedArtist && filter.selectedArtist.value)
            )
          "
          :placeholder="$t('artist')"
          deselect
          deselectLabel="Select All"
          v-on:selectedChange="(e) => onDropdownChange('artist', e)"
          :listHeight="400"
        ></Dropdown>
        <Dropdown
          :options="staffs"
          v-if="staffs && staffs.length > 0"
          :selected="
            staffs.find(
              (e) =>
                e.value == (filter.selectedStaff && filter.selectedStaff.value)
            )
          "
          :placeholder="$t('staff')"
          deselect
          deselectLabel="Select All"
          v-on:selectedChange="(e) => onDropdownChange('Staff', e)"
          :listHeight="400"
        ></Dropdown>
        <InputField
          :value="searchString"
          :placeholder="$t('country_city_iso')"
          :config="{
            borderStyle: 'bottom',
          }"
          @keyup="onSearchInputKeyup"
        />
        <button
          v-if="calendarRoute"
          class="dt-button s0 filter-bar-button"
          @click="onTodayClick"
        >
          {{$t('today')}}
        </button>

        <!-- <v-menu offset-y class="bl-more-menu">
          <button class="dt-button s0 filter-bar-button" slot="activator">
            <v-icon>more_horiz</v-icon>
          </button>
          <v-list class="filter-more-options-list">
            <v-list-tile
              class="options-item"
              v-for="(item, index) in dropdownItems"
              :key="index"
              @click="e => onMenuItemClicked(item)"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>-->

        <div class="status-selection-container">
          <div class="max-min-button">
            <img
              v-if="!statusSelMaximized"
              @click="maximizeSelectionContainer"
              class="dt-icon v5 s1"
              src="static/icons/arrows/chevron-down.svg"
              alt
            />
            <img
              v-if="statusSelMaximized"
              @click="minimizeSelectionContainer"
              class="dt-icon v5 s1"
              src="static/icons/arrows/chevron-up.svg"
              alt
            />
          </div>
          <div class="status-selection">
            <div
              class="status-item"
              v-for="status of statusesTV"
              :key="status.value"
            >
              <div class="status-checkbox">
                <div class="dt-checkbox v2">
                  <input
                    type="checkbox"
                    :name="status.value"
                    :id="status.value"
                    :title="status.text"
                    :checked="
                      filter.selectedStatuses
                        .map((e) => e.value)
                        .includes(status.value)
                    "
                    @click="(e) => onStatusSelected(e, status)"
                  />
                  <div
                    class="checkmark"
                    :style="{
                      backgroundColor: filter.selectedStatuses
                        .map((e) => e.value)
                        .includes(status.value)
                        ? `#${
                            statuses.find(
                              (e) => e.booking_status_id == status.value
                            ).booking_status_colour
                          }`
                        : `transparent`,
                      borderColor: `#${
                        statuses.find(
                          (e) => e.booking_status_id == status.value
                        ).booking_status_colour
                      }`,
                    }"
                  ></div>
                </div>
              </div>
              <div class="status-text" v-if="statusSelMaximized">
                {{ status.text }}
              </div>
            </div>
            <div class="status-item">
              <div class="status-checkbox select-all">
                <div class="dt-checkbox">
                  <input
                    type="checkbox"
                    :name="'select-all'"
                    :id="'select-all'"
                    :checked="
                      filter.selectedStatuses.length === statusesTV.length
                    "
                    @click="(e) => onSelectAllStatuses(e)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
              <div
                class="status-text select-all-text"
                v-if="statusSelMaximized"
              >
                {{$t('select_all_none')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="listRoute">
      <NTable
        style="margin-left: 5px"
        :config="tableConfig"
        :headers="headers"
        :items="cmpBookingList || []"
        :id="'booking-booking-booking_list'"
        class="h1"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:thead="{ thcon, thtext }">
          <tr>
            <th
              v-for="(header, index) in headers"
              v-bind="thcon(header.value)"
              :key="header.value"
            >
              <!-- <div v-if="index == 0" class="header-name"></div> -->
              <div
                v-if="
                  index !== headers.length - 1 &&
                  !['start_date', 'artist_name'].includes(header.value)
                "
                class="header-name"
              >
                {{ thtext(header.value) }}
              </div>

              <div
                v-else-if="['start_date', 'artist_name'].includes(header.value)"
                class="header-name"
              >
                <div class="ut-flex">
                  <div>
                    {{ thtext(header.value) }}
                  </div>
                  <div
                    :style="{ visibility: showFilter ? `visible` : 'hidden' }"
                    class="sorting-name"
                    style="margin-top: 5px; margin-right: -10px"
                  >
                    <img
                      @click="() => changeSortOrder(header.value)"
                      class="dt-icon v5 s1"
                      :src="
                        filter.sort[header.value] == 'asc'
                          ? 'static/icons/arrows/chevron-up-red.svg'
                          : filter.sort[header.value] == 'desc'
                          ? 'static/icons/arrows/chevron-down-red.svg'
                          : 'static/icons/minus.svg'
                      "
                      alt
                    />
                  </div>
                </div>
              </div>
              <div v-else class="header-name">
                <div class="bp-filters">
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_c')"
                    :class="[filter.bpFilter['status_c']]" :title=" $t('contract') + ' ' + filterTitle(getBPFilterSrc('status_c'))
                      " :src="`static/icons/contract/contact-gray.svg`" alt />
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_r')"
                    :class="[filter.bpFilter['status_r']]" :title=" $t('rider') + ' ' + filterTitle(getBPFilterSrc('status_r'))"
                    :src="`static/icons/itinerary/itinerary-gray.svg`" alt />
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_l')"
                    :class="[filter.bpFilter['status_l']]" :title=" $t('local') + ' ' + filterTitle(getBPFilterSrc('status_l'))"
                    :src="`static/icons/localdetails/localdetails-gray.svg`" alt />
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_t')"
                    :class="[filter.bpFilter['status_t']]" :title=" $t('travel') + ' ' + filterTitle(getBPFilterSrc('status_t'))"
                    :src="`static/icons/airplane/airplane-gray.svg`" alt />
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_i')"
                    :class="[filter.bpFilter['status_i']]" :title=" $t('invoice') + ' ' + filterTitle(getBPFilterSrc('status_i'))
                      " :src="`static/icons/finance/finance-gray.svg`" alt />
                  <img class="dt-icon s1" @click="(e) => onBPFilterClick('status_exclusivity')"
                    :class="[filter.bpFilter['status_exclusivity']]" :title=" $t('exclusivity') + ' ' + filterTitle(getBPFilterSrc('status_exclusivity'))
                      " :src="`static/icons/artist-exclusivity/artist-exclusivity.svg`" alt />
                      <img v-if="bookingProcessStyle==='with_icon'" @click="onBookingProcessClick" class="dt-icon s1  status_j"  :src="`static/icons/eye.svg`" alt />
                      <img v-if="bookingProcessStyle==='with_circle'" @click="onBookingProcessClick" class="dt-icon s1  status_j"  :src="`static/icons/eye-slash.svg`" alt />
                </div>
              </div>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon }">
          <tr
            style="cursor: text"
            :title="`${item['start_date']}-${item['artist_name']}-${item['city']}`"
            :class="{
              selected: selectedRow(item),
            }"
            :ref="'calendar_date_artist_' + item['PRIMARY_KEY']"
            @click="onRowClicked(item)"
          >
            <!-- <td v-bind="tdcon('left_options')">
              <div class="dt-checkbox v2 s1">
                <input @click="(e) => onBookingCheckboxChange(e, item)" type="checkbox" class="invoice-select-cb"
                  :checked="checkedBookingLocationID.includes(item.booking_location_id)" />
                <div class="checkmark"></div>
              </div>
            </td> -->
            <td style="cursor: pointer" v-bind="tdcon('start_date')">
              <div class="ut-flex" style="gap: 0.5rem">
                <div class="booking-status-cirtext--circle">
                  <div
                    class="circle"
                    :style="{
                      backgroundColor: `#${item['booking_status_colour']}`,
                    }"
                  ></div>
                </div>
                <div class="multilineLeft" @click.stop="onRowClicked(item)">
                  <span class="txtov" style="font-weight: bold">{{
                    item["start_date"]
                  }}</span>
                  <span class="txtov2">{{ item["booking_status_name"] }}</span>
                </div>
              </div>
            </td>
            <td
              style="cursor: pointer"
              v-bind="tdcon('artist_name')"
              @click.stop="onArtistNameClicked(item)"
              :title="'Click to see ' + item['artist_name'] + '\'s Details'"
            >
              <span class="ut-link ut-text-accent5">{{ item["artist_name"] }}</span>
            </td>
            
            <td style="cursor: pointer" v-bind="tdcon('venue_event_name')">
              <div class="multilineLeft">
                <span class="txtov"  @click="onVenueClick(item)">{{ item["booking_location_name"]}}</span>
                <span class="txtov2">{{ item["date_name"]}}</span>
              </div>
            </td>
            <td v-bind="tdcon('city_country')">
              <div class="multilineLeft">
                <span class="txtov">{{ item["city"] }}</span>
                <span class="txtov2">{{ item["country"] }}</span>
              </div>
            </td>
            <!-- <td v-bind="tdcon('country')">
              <span>{{ item["country"] }}</span>
            </td> -->
            <td v-bind="tdcon('booking_process')">
              <div :class="`booking_process ${bookingProcessStyle}`" >
                <div class="stat-ico-container" :title="$t('contract') + ' ' + flagTitle(getContractClass(item))"
                  :class="getContractClass(item)">
                  <img class="status-icon" :src="`static/icons/contract/contact-${flagSrc(
                    getContractClass(item)
                  )}.svg`" alt />
                </div>
                <div
                  class="stat-ico-container"
                  :title="$t('rider') + ' ' + flagTitle(getRiderClass(item))"
                  :class="getRiderClass(item)"
                >
                  <img
                    class="status-icon itinerary-gray"
                    :src="`static/icons/itinerary/itinerary-${flagSrc(
                      getRiderClass(item)
                    )}.svg`"
                    alt
                  />
                </div>
                <div
                  class="stat-ico-container"
                  :title="$t('local') + ' ' + flagTitle(getLocalClass(item))"
                  :class="getLocalClass(item)"
                >
                  <img
                    class="status-icon"
                    :src="`static/icons/localdetails/localdetails-${flagSrc(
                      getLocalClass(item)
                    )}.svg`"
                    alt
                  />
                </div>
                <div
                  class="stat-ico-container"
                  :title="$t('travel') + ' ' + flagTitle(getTravelClass(item))"
                  :class="getTravelClass(item)"
                >
                  <img
                    class="status-icon"
                    :src="`static/icons/airplane/airplane-${flagSrc(
                      getTravelClass(item)
                    )}.svg`"
                    alt
                  />
                </div>
                <div
                  class="stat-ico-container"
                  :title="$t('invoice') + ' ' + flagTitle(getInvoiceClass(item))"
                  :class="getInvoiceClass(item)"
                >
                  <img
                    class="status-icon"
                    :src="`static/icons/finance/finance-${flagSrc(
                      getInvoiceClass(item)
                    )}.svg`"
                    alt
                  />
                </div>
                <div
                  class="stat-ico-container"
                  :class="getExclusivityClass(item)"
                  style="padding-top: 7px;"
                >
                <!-- :title="$t('exclusivity') + ' ' + flagTitle(getExclusivityClass(item))" -->
                  <v-menu open-on-hover bottom left offset-y max-width="768">
                    <img
                      class="status-icon"
                      :src="`static/icons/artist-exclusivity/artist-exclusivity-${flagSrc(
                        getExclusivityClass(item)
                      )}.svg`"
                      slot="activator"
                    />

                    <v-card>
                      <div class="info-card-body">
                        <div v-html="exclusivityTooltip(item)"></div>
                      </div>
                    </v-card>
                  </v-menu>
                </div>
                <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => onBookingItemMailClick(e, item)"
                    src="static/icons/email/email-grey.svg"
                    class="mail-icon dt-icon v5 s1"
                    alt
                    v-if="item['promoter_email1'] || item['contact_email1']"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </template>
    <template v-if="calendarRoute">
      <CalendarView
        v-if="filter.selectedMonths"
        :selectedDateBox="selectedDateBox"
        :selectedMonth="filter.selectedMonths.text"
        :bookingArtistList="filteredBookingArtistList"
        :showExternalCalendar="showExternalCalendar"
        :externalDates="externalDates"
        :statusColorMap="statusColorMap"
        :class="{
          'dt-loading': bookingArtistListLoading,
        }"
        @eventClicked="onCalendarEventClick"
        @eventAdd="onEventAddCalendar"
        @prev_month="previousMonthClick"
        @next_month="nextMonthClick"
      ></CalendarView>
    </template>

    <!-- <v-navigation-drawer
          temporary
          :right="right"
          :clipped="clipped"
          :width=1200
          :value="bookingDetailsFlag"
          fixed
          stateless
          touchless
          hide-overlay
          app

          @input="onInputChage"
      >
      <BookingSidewindow
      @closeBookingDetails="onCloseBookingDetails"
      ></BookingSidewindow>

    </v-navigation-drawer>-->

    <Sidewindow :value="bookingDetailsFlag" @closed="onCloseBookingDetails">
      <BookingSidewindow
        @closeBookingDetails="onCloseBookingDetails"
        @deleted="onBookingDeleted"
        @reloadBookingList="() => makeRequest()"
      ></BookingSidewindow>
    </Sidewindow>

    <template v-if="sendDocumentFilesModalContainer">
      <v-dialog v-model="sendDocumentFilesModal" width="1200">
        <SendDocumentFiles
          @openEmailModal="openEmailModal"
          @cancelled="onSendDocumentFilesCancel"
        />
      </v-dialog>
    </template>

    <template v-if="addBookingModalContainer">
      <v-dialog persistent v-model="addBookingModal" width="762">
        <AddBooking
          :currency="'EUR'"
          @done="onAddBookingDone"
          @cancelled="onAddBookingCancelled"
        />
      </v-dialog>
    </template>
    <!-- <ModalContainer
      :modalKey="'chooseMailTemplate'"
      :width="'small'"
      @cancelled="onHideComponentModal"
    >
      <ChooseMailTemplate
        :emailDetails="emailDetail"
        @cancelled="onHideComponentModal"
      ></ChooseMailTemplate>
    </ModalContainer> -->
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";
import { format } from "date-fns";

import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";

import Dropdown from "@plugins/dropdown/dropdown";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";

import BookingSidewindow from "../components/booking-sidewindow/booking-sidewindow";
import Sidewindow from "../../../dt-plugins/sidewindow/sidewindow";
import SendDocumentFiles from "../components/send-doc-files";
import AddBooking from "../components/add-booking";

import {
  getBookingStatuses,
  mapBookingToIds,
  previous10YearsMonthsDropdown,
  createDropdownItem,
  EXTERNAL_CALENDAR_DATE,
} from "../models/booking-artist.model";
import {
  childOf,
  childOfOrEqual,
  childOfOrEqualSome,
} from "../../../router/functions";
import {
  waitForAnimation,
  getCalendarGrid,
  createMailHref,
  decode,
  encodeRoute,
  subscribeSubject,
  subscribeSubjectND,
} from "../../../utility";
import {
  calendarDateSelectable,
  bookingListCalendarDateRoute,
  bookingListCalendarDateTabRoute,
  SelectResults,
  bookingCalRoute,
  bookingListRoute,
  bookingCalCalendarDateRoute,
  bookingCalCalendarDateTabRoute,
  artistDetailsRoute,
  artistDetailsTabRoute,
  bookingVenueRoutes,
} from "../router/router";
import {
  StatusColorNames as SCN,
  getBPFilterDict,
  getBPFilter,
  cycleBPFilter,
} from "../models/status-colors";

import CalendarView from "../components/calendar";
import { BookingService } from "../services/booking-service";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../dt-plugins/confirmation/confirmation.service";
import { handleFromRoute } from "../../../utility/route";
import { last } from "ramda";

import ChooseMailTemplate from "../components/choose-mail-template";

import { DocumentsService } from "../services/booking-details/documents.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";
import { Subject } from "rxjs";
import TextField from "@plugins/text-field/text-field";
import { bookingArtistListLDTRoutes } from "../router/routes";
import { showError } from "../../../dt-plugins/notification/notification.service";
//import InputField from "@plugins/text-field/input-field";
// console.log(getBookingStatuses());
const childOfBookingCalendar = childOfOrEqual(bookingListCalendarDateRoute);

// const childOfBookingList = childOfOrEqual(bookingListR);

export default {
  components: {
    BookingSidewindow,
    Dropdown,
    InputField,
    SendDocumentFiles,
    AddBooking,
    CalendarView,
    NTable,
    Sidewindow,
    ModalContainer,
    ChooseMailTemplate,
  },
  mixins: [],
  data: function () {
    return {
      searchString: "",
      textFieldConfig: {
        height: 40,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      right: true,
      clipped: false,
      search: "",
      checkedBookingLocationID: [],
      bookingStatuses: getBookingStatuses(),
      dropdownItems: [
        { text: "Text1", value: "value1" },
        { text: "Text2", value: "value2" },
        { text: "Text3", value: "value3" },
        { text: "Text4", value: "value4" },
        { text: "Text5", value: "value5" },
      ],
      // bookingMonths: previous10YearsMonthsDropdown,
      // selectedMonths: createDropdownItem(new Date()),
      // selectedStatuses: [],
      // selectedArtist: [],
      // selectedStaff: {},

      sendDocumentFilesModalContainer: false,
      sendDocumentFilesModal: false,

      addBookingModalContainer: false,
      addBookingModal: false,

      statusSelMaximized: false,
      dropdownItems: [
        // { title: 'Artist' },
        // { title: 'User' },
        { title: "External Calendar" },
        { title: "Free Dates" },
        { title: "Request Form" },
        { title: "Available Artists" },
      ],

      showExternalCalendar: false,

      bpFilterDict: getBPFilterDict(),

      selectedCalendarDateArtist: null,
      selectedDateBox: null,
      emailDetail: null,
      searchSubject$: new Subject(),
      scrollSubject: new Subject(),
      isAsc: true,

      bookingProcessStyle: "with_icon",

      loadingFlag: false,
      artistsTV: [],

      // MARK: Datas
    };
  },
  mounted: async function () {
    // this.routeMount();

    subscribeSubject(this, this.searchSubject$, (searchString) => {
      this.fetchListSearch(searchString);
    });

    subscribeSubjectND(this, this.scrollSubject, (scrollTop) => {
      this.fetchListScroll();
    });

    //Load artists for artist dropdown filter
    const artistResponse = await BookingService.findAllArtists();
    this.artistsTV = artistResponse.data.all_artist
      .map((artist) => ({ text: artist.artist_name, value: artist.artist_id }))
      .filter((tv) => tv.text != null)
      .filter((tv) => {
        const booking_artists = this.$store.getters.account?.user_permissions?.blocked?.booking_artists;
        
        if (booking_artists && booking_artists.includes(`${tv.value}`)) {
          return false;
        } else {
          return true;
        }
      });
      ;
  },
  computed: {
    ...mapGetters(storeNS, {
      // Filters
      filter: "filter",
      listFilter: "listFilter",
      artists: "artists",
      staffs: "staffs",
      statuses: "statuses",
      statusesTV: "statusesTV",
      monthsTV: "monthsTV",

      statusColorMap: "statusColorMap",

      items: "bookingList",
      bookingArtistList: "bookingArtistList",
      bookingArtistListLoading: "bookingArtistListLoading",
      filteredBookingArtistList: "filteredBookingArtistList",
      // bookingDetailsFlag: 'bookingDetailsFlag',
      selectedBooking: "selectedBooking",
      selectedMonths: "selectedMonths",

      externalDates: "externalDates",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 48,
        scrollNextThreshold: 30,
      });
    },
    cmpBookingList: function () {
      return this.filteredBookingArtistList;

      // The Component Filtering is Turned off For now - Probably will be done as Backend Sorting instead.

      // const tempList = [...this.filteredBookingArtistList];
      // return this.isAsc
      //   ? tempList.sort(
      //       (a, b) =>
      //         new Date(a.start_date).getTime() -
      //         new Date(b.start_date).getTime()
      //     )
      //   : tempList.sort(
      //       (a, b) =>
      //         new Date(b.start_date).getTime() -
      //         new Date(a.start_date).getTime()
      //     );
    },

    headers: function () {
      return [
       // createTableHeader("left_options", { mw: 25, ta: "center" }),
        createTableHeader("start_date", { f: 0.9  }),
        createTableHeader("artist_name"),
        // createTableHeader("booking_status_name", { text: this.$t("status") }),
        createTableHeader("venue_event_name"),
        // createTableHeader("city", { f: 0.5 }),
        createTableHeader("city_country"),
        createTableHeader("booking_process", { minw: 250 }),
      ];
    },
    bookingDetailsFlag: function () {
      return childOfOrEqualSome([bookingListCalendarDateRoute])(
        this.$route.name
      );
    },
    calendarRoute: function () {
      return childOfOrEqual(bookingCalRoute)(this.$route.name);
    },
    listRoute: function () {
      return childOfOrEqual(bookingListRoute)(this.$route.name);
    },
    showFilter: function () {
      console.log(
        "Object.values(this.filter.bpFilter)",
        Object.values(this.filter.bpFilter)
      );
      return Object.values(this.filter.bpFilter).filter(
        (value) => value == "Gray"
      ).length === Object.values(this.filter.bpFilter).length
        ? false
        : true;
    },
    calendarGrid: function () {
      return (
        this.filter.selectedMonths &&
        getCalendarGrid(new Date(this.filter.selectedMonths.text))
      );
    },

    i18nMonthsTV: function () {
      return geti18nMontshDate(this, this.monthsTV);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        const { selectResult, calendarDateId } = calendarDateSelectable(
          to,
          from
        );
        console.log("MDSIR booking route ", selectResult);
        if (selectResult == SelectResults.SELECT) {
          this.selectCalendarDate(parseInt(calendarDateId, 10));
        } else if (selectResult == SelectResults.SELECT_AUTO) {
          this.selectBookingAutonomouse(parseInt(calendarDateId, 10));
        } else if (selectResult == SelectResults.CLOSE) {
          this.closeBookingSideWindow();
        }

        if (!from && selectResult !== SelectResults.SELECT_AUTO) {
          // console.log("NOT FROM MKRQ");

          if (
            this.filteredBookingArtistList &&
            this.filteredBookingArtistList.length == 0
          ) {
            // If Booking List is Zero -- Probably this is the first Route Load
            this.makeRequest();
          }
        }

        // Close Booking Details Route
        // if (to.name === bookingListR && from && childOfBookingCalendar(from.name)) {
        //   this.closeBookingSideWindow();
        // }

        if (to && to.query.modal === "add_booking") {
          this.addBookingModalContainer = true;
          setTimeout(() => {
            this.addBookingModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "add_booking" &&
          to.query.modal !== "add_booking"
        ) {
          this.addBookingModal = false;
          waitForAnimation(() => {
            this.addBookingModalContainer = false;
          });
        }

        // Send Document Files Modal
        if (to && to.query.modal === "send_doc_files") {
          if (
            to.query.calendar_date_id &&
            parseInt(to.query.calendar_date_id) > 0
          ) {
            this.sendDocumentFilesModalContainer = true;
            this[ActionTypes.FETCH_SEND_DOCUMENT_FILES_DATA]({
              calendar_date_id: to.query.calendar_date_id,
            });

            setTimeout(() => {
              this.sendDocumentFilesModal = true;
            }, 1);
          }
        } else if (
          from &&
          from.query.modal === "send_doc_files" &&
          to.query.modal !== "send_doc_files"
        ) {
          this.sendDocumentFilesModal = false;
          waitForAnimation(() => {
            this.sendDocumentFilesModalContainer = false;
          });
        }
      },
    },
  },
  methods: {
    changeSortOrder: async function (sortField) {
      // this.isAsc = !this.isAsc;
      const sortStates = ["asc", "desc", "none"];
      const currentState = this.filter.sort[sortField] ?? "none";
      const newStateIndex =
        sortStates.indexOf(currentState) == 2
          ? 0
          : sortStates.indexOf(currentState) + 1;

      await this.filterList({
        sort: {
          // ...this.filter.sort,
          // start_date: this.filter.sort.start_date == "asc" ? "desc" : "asc",
          [sortField]: sortStates[newStateIndex],
        },
      });
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(this.searchString);
    },
    routeMount: function () {
      if (childOfBookingCalendar(this.$route.name)) {
        const calendarDateId = this.$route.params.calendar_date_id;

        const tabName =
          this.$route.name === bookingListCalendarDateTab
            ? this.$route.params["tab"]
            : undefined;
        if (isValidCalendarDateId(calendarDateId)) {
          this.selectBookingAutonomouse(parseInt(calendarDateId, 10), tabName);
        } else {
          // console.log("INV CDID MKRQ");
          this.makeRequest();
        }

        if (this.$route.name === bookingListCalendarDateTab) {
          this[ActionTypes.SET_BOOKING_TAB](this.$route.params["tab"]);
        }
      } else {
        // console.log("NOT CHILD MK REQ");
        this.makeRequest();
      }
    },
    ...mapMutations(storeNS, {
      [ActionTypes.SET_BOOKING_TAB]: ActionTypes.SET_BOOKING_TAB,
    }),
    ...mapActions(storeNS, {
      [ActionTypes.SET_SELECTED_BOOKING]: ActionTypes.SET_SELECTED_BOOKING,
      [ActionTypes.SET_SELECTED_BOOKING_AUTONOMOUSE]:
        ActionTypes.SET_SELECTED_BOOKING_AUTONOMOUSE,
      [ActionTypes.CLOSE_BOOKING_DETAILS]: ActionTypes.CLOSE_BOOKING_DETAILS,
      [ActionTypes.FETCH_BOOKING_ARTIST_LIST]:
        ActionTypes.FETCH_BOOKING_ARTIST_LIST,
      [ActionTypes.FETCH_SEND_DOCUMENT_FILES_DATA]:
        ActionTypes.FETCH_SEND_DOCUMENT_FILES_DATA,
      [ActionTypes.DOCUMENTDATA.FETCH.ALL]: ActionTypes.DOCUMENTDATA.FETCH.ALL,
      [ActionTypes.UPDATE_FILTER]: ActionTypes.UPDATE_FILTER,
      [ActionTypes.FETCH_EXTERNAL_CALENDAR_DATES]:
        ActionTypes.FETCH_EXTERNAL_CALENDAR_DATES,
      [ActionTypes.BookingDetails.DELETE.SINGLE]:
        ActionTypes.BookingDetails.DELETE.SINGLE,
      [ActionTypes.FETCH_BOOKING_ARTIST_LIST_NEXT]:
        ActionTypes.FETCH_BOOKING_ARTIST_LIST_NEXT,
    }),
    ...mapMutations(storeNS, {
      [ActionTypes.SET_SELECTED_MONTHS]: ActionTypes.SET_SELECTED_MONTHS,
    }),
    setSelectedCalendarDateArtist: function (item) {
      this.selectedCalendarDateArtist = item;

      waitForAnimation(() => {
        const selectedRow =
          this.$refs[`calendar_date_artist_${item.PRIMARY_KEY}`];
        if (selectedRow) {
          selectedRow.scrollIntoView();
        }
      });
    },
    onRowClicked: async function (item) {
      const has_permission = await BookingService.has_permission(
        item.calendar_date_id
      );

      if (
        has_permission.user_permission == 0 ||
        has_permission.calendar_date_exists == 0
      ) {
        showError(this.$t("permission_denied"));
        return;
      }

      this.selectedCalendarDateArtist = item;
      const tab = this.$route.params.tab;
      if (tab) {
        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: { calendar_date_id: item.calendar_date_id, tab: tab },
        });
      } else {
        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: { calendar_date_id: item.calendar_date_id, tab: "overview" },
        });
      }
    },
    onArtistNameClicked: function (item) {
      // console.log({
      //   name: artistDetailsTabRoute,
      //   params: {
      //     artist_id: bookingArtist.artist_id,
      //     tab: 'overview'
      //   }
      // });

      this.$router.push({
        name: bookingArtistListLDTRoutes.names.tab,
        params: {
          artist_id: item.artist_id,
          tab: "overview",
        },
      });

      // this.$router.push({
      //   name: artistDetailsTabRoute,
      //   params: {
      //     artist_id: bookingArtist.artist_id,
      //     tab: "overview",
      //   },
      //   query: {
      //     from: encodeRoute(this.$route),
      //   },
      // });
    },
    selectBookingAutonomouse: function (calendar_date_id, tab = "overview") {
      this[ActionTypes.SET_SELECTED_BOOKING_AUTONOMOUSE](
        { calendar_date_id },
        tab
      );
    },
    selectCalendarDate: function (calendar_date_id) {
      const sb = this.bookingArtistList.find(
        (e) => e.calendar_date_id == calendar_date_id
      );
      if (sb) {
        this[ActionTypes.SET_SELECTED_BOOKING](sb);
      } else {
        this[ActionTypes.SET_SELECTED_BOOKING]({ calendar_date_id });
      }
    },
    onInputChage: function (e) {
      if (!e) {
        this[ActionTypes.CLOSE_BOOKING_DETAILS]();
      }
    },
    onDropdownChange: async function (name, e) {
      switch (name) {
        case "month": {
          // this[ActionTypes.SET_SELECTED_MONTHS](e);

          // this.makeRequest();

          await this.filterList({
            selectedMonths: e,
          });

          // this.makeRequest();

          break;
        }
        case "artist": {
          // if (this.selectedArtist && this.selectedArtist.value === e.value) {
          //   this.selectedArtist = {};
          // } else {
          //   this.selectedArtist = e;
          // }

          // console.log(e);
          await this.filterList({
            selectedArtist: e,
          });
          // this.makeRequest();

          break;
        }
        case "status": {
          // this.selectedStatuses = e;

          await this.filterList({
            selectedStatuses: e,
          });
          // this.makeRequest();

          break;
        }
        case "Staff": {
          if (this.selectedStaff && this.selectedStaff.value === e.value) {
            this.selectedStaff = {};
          } else {
            this.selectedStaff = e;
          }

          // console.log(this.selectedStaff);

          await this.filterList({
            selectedStaff: e,
          });
          // this.makeRequest();

          break;
        }
      }

      // console.log(this.filter, this.listFilter);
    },
    makeRequest: async function () {
      // const bookingIds = mapBookingToIds(this.selectedStatuses).map(e => `"${e}"`);

      // const status = `[${bookingIds.join(",")}]`;
      // console.log("MAKE REQ");
      return await this[ActionTypes.FETCH_BOOKING_ARTIST_LIST]();
    },
    onCloseBookingDetails: function (value) {
      this.selectedCalendarDateArtist = null;
      this.closeBookingSideWindow();
      handleFromRoute(this, () => {
        this.$router.push({ name: bookingListRoute });
      });
    },
    closeBookingSideWindow: function () {
      this[ActionTypes.CLOSE_BOOKING_DETAILS]();
    },
    onBookingItemMailClick: function (e, item) {
      e.stopPropagation();
      e.preventDefault();

      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "send_doc_files",
          calendar_date_id: item.calendar_date_id,
        },
      });
    },
    onSendDocumentFilesCancel: function (e) {
      this[ActionTypes.DOCUMENTDATA.FETCH.ALL]({});
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
          calendar_date_id: undefined,
        },
      });
    },
    onAddBookingClicked: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_booking" },
      });
    },
    onAddBookingCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
          start_date: undefined,
          end_date: undefined,
        },
      });
    },
    onAddBookingDone: async function (calendarDateId) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
      await this.makeRequest();
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: { calendar_date_id: calendarDateId, tab: "overview" },
      });
    },
    previousMonthClick: function () {
      const currentIndex = this.i18nMonthsTV.findIndex(
        (m) => m.value == this.filter.selectedMonths.value
      );
      if (currentIndex - 1 >= 0) {
        const previousMonth = this.i18nMonthsTV[currentIndex - 1];
        this.filterList({
          selectedMonths: previousMonth,
        });
      } else {
        // this.filterList({
        //   selectedMonths: last(this.i18nMonthsTV),
        // });
      }
      const currentMonth = this.i18nMonthsTV.find(
        (m) => m.value == this.filter.selectedMonth
      );
      console.log({ "booking-list.vue:1110 currentMonth": currentMonth });
    },
    nextMonthClick: function () {
      const currentIndex = this.i18nMonthsTV.findIndex(
        (m) => m.value == this.filter.selectedMonths.value
      );
      if (currentIndex + 1 < this.i18nMonthsTV.length) {
        const previousMonth = this.i18nMonthsTV[currentIndex + 1];
        this.filterList({
          selectedMonths: previousMonth,
        });
      } else {
        // this.filterList({
        //   selectedMonths: last(this.i18nMonthsTV),
        // });
      }
    },
    gotoMonth: function (year_month) {
      const month = this.i18nMonthsTV.find((m) => m.value == year_month);
      // console.log(
      //   "Log: this.filter.selectedMonths.value",
      //   this.filter.selectedMonths.value
      // );
      // console.log("Log: month", month);
      if (month && month.value != this.filter.selectedMonths.value) {
        this.filterList({
          selectedMonths: month,
        });
      }
    },

    onStatusSelected: function (e, status) {
      // console.log(status, e.target.checked);
      const findStatus = this.filter.selectedStatuses.find(
        (s) => s.value == status.value
      );
      if (e.target.checked) {
        if (!findStatus) {
          this.filterList({
            selectedStatuses: [...this.filter.selectedStatuses, status],
          });
        }
      } else {
        if (findStatus) {
          this.filterList({
            selectedStatuses: this.filter.selectedStatuses.filter(
              (e) => e.value != findStatus.value
            ),
          });
        }
      }
    },

    onSelectAllStatuses: function (e) {
      if (e.target.checked) {
        this.filterList({
          selectedStatuses: [...this.statusesTV],
        });
      } else {
        this.filterList({
          selectedStatuses: [],
        });
      }
    },

    maximizeSelectionContainer: function () {
      this.statusSelMaximized = true;
    },

    minimizeSelectionContainer: function () {
      this.statusSelMaximized = false;
    },

    onCalendarEventClick: function (event) {
      // console.log(event);

      if (event.booking_status_name === EXTERNAL_CALENDAR_DATE) {
        ConfirmationService.create({
          subject: `Notes`,
          body: event.city,
          model: true,
          width: 500,
          results: [
            createConfirmResult({
              value: "Cancel",
            }),
          ],
          completed: (res) => {
            switch (res) {
              case "Cancel": {
                break;
              }
              default: {
              }
            }
          },
        });
      } else {
        this.setSelectedCalendarDateArtist(event);
        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: { calendar_date_id: event.calendar_date_id, tab: "overview" },
          query: {
            from: encodeRoute(this.$route),
          },
        });
      }

      // this.$router.push({name: bookingCalCalendarDateTabRoute, params: {calendar_date_id: event.calendar_date_id, tab: 'overview'}})
    },
    onEventAddCalendar: function ({ start_date, end_date }) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "add_booking",
          start_date,
          end_date,
        },
      });
    },
    onTodayClick: function () {
      const today = new Date();
      this.selectedDateBox = today;

      const year_month = format(today, "YYYYMM");
      // console.log(year_month);
      this.gotoMonth(format(today, "YYYYMM"));
    },
    // onMenuItemClicked: function(item) {
    //   console.log(item);
    //   switch (item.title) {
    //     case "External Calendar": {
    //       if (!this.showExternalCalendar) {
    //         this.showExternalCalendar = true;
    //         this[ActionTypes.FETCH_EXTERNAL_CALENDAR_DATES]({
    //           month: format(this.filter.selectedMonths.date, "YYYY-MM")
    //         });
    //       } else {
    //         this.showExternalCalendar = false;
    //       }
    //       break;
    //     }
    //     case "Free Dates": {
    //       this.$router.push({
    //         ...this.$route,
    //         query: {
    //           modal: "free_dates"
    //         }
    //       });
    //       break;
    //     }
    //     case "Request Form": {
    //       BookingService.requestFormMail().then(res => {
    //         const templateId = res.data.templates[0].template_id;
    //         const description = res.data.templates[0].description;
    //         BookingService.requestFormMailUrl({
    //           templateId
    //         }).then(urlResult => {
    //           console.log(urlResult.data.render_text);
    //           const render_text = urlResult.data.render_text;
    //           location.href = createMailHref({
    //             subject: description,
    //             body: render_text
    //           });
    //         });
    //       });
    //       break;
    //     }
    //     case "Available Artists": {
    //       break;
    //     }
    //   }
    // },

    flagTitle: function (name) {
      switch (name[0]) {
        case SCN.Green: {
          return "Active";
        }
        case SCN.Yellow: {
          return "In Progress";
        }
        case SCN.Red: {
          return "Inactive";
        }
        case SCN.Gray: {
          return "";
        }
        default: {
          return "";
        }
      }
    },
    flagSrc: function (name) {
      switch (name[0]) {
        case SCN.Green: {
          return "active";
        }
        case SCN.Yellow: {
          return "orange";
        }
        case SCN.Red: {
          return "inactive";
        }
        case SCN.Gray: {
          return "gray";
        }
        default: {
          return "gray";
        }
      }
    },
    filterTitle: function (filter) {
      switch (filter) {
        case "gray": {
          return "";
        }
        case "active": {
          return "Active";
        }
        case "inactive": {
          return "Inactive";
        }
        case "orange": {
          return "In Progress";
        }
      }
    },
    getContractClass: function (booking) {
      return [
        booking.contracts_signed_flag == "1"
          ? SCN.Green
          : booking.contracts_out_flag == "1"
          ? SCN.Yellow
          : SCN.Red,
      ];
    },
    getRiderClass: function (booking) {
      return [
        booking.itinerary_artist_flag == "1"
          ? SCN.Green
          : booking.itinerary_promoter_flag == "1"
          ? SCN.Yellow
          : SCN.Red,
      ];
    },
    getLocalClass: function (booking) {
      return [
        booking && booking.local_details_confirmed_flag == "1"
          ? SCN.Green
          : SCN.Red,
      ];
    },
    getTravelClass: function (booking) {
      // const c1 = Number(booking.c1) || 0;
      // const c2 = Number(booking.c2) || 0;
      // return [c1 && c2 && c1 == c2 ? SCN.Green : SCN.Red];

      return [booking.travel_status_color == "GREEN" ? SCN.Green : SCN.Red];
    },
    getInvoiceClass00: function (booking) {
      const total_invoices = Number(booking.total_invoices) || 0;
      const paid_invoices = Number(booking.paid_invoices) || 0;
      const cancelled_invoices = Number(booking.cancelled_invoices) || 0;
      const partially_paid_invoices =
        Number(booking.partially_paid_invoices) || 0;

      if (
        paid_invoices > 0 &&
        total_invoices == paid_invoices + cancelled_invoices
      ) {
        return [SCN.Green];
      } else if (paid_invoices > 0 || partially_paid_invoices > 0) {
        return [SCN.Yellow];
      } else {
        return [SCN.Red];
      }
      //  else if (booking.invoices_out_flag == 1) {
      //   return [SCN.Green];
      // }
      return true;
    },
    getInvoiceClass: function (booking) {
      switch (booking.invoice_status_color) {
        case "RED":
          return [SCN.Red];
        case "GREEN":
          return [SCN.Green];
        case "YELLOW":
          return [SCN.Yellow];
        default:
          break;
      }
    },
    getExclusivityClass: function (booking) {
      // console.log('booking.exclusive_icon:', booking.exclusive_icon);
      switch (booking.exclusive_icon) {
        case "RED":
          return [SCN.Red];
        case "GREEN":
          return [SCN.Green];
        case "GREY":
          return [SCN.Gray];
        default:
          break;
      }
    },
    onBPFilterClick: function (filter) {
      this.filterList({
        bpFilter: cycleBPFilter(filter, this.filter.bpFilter),
      });
    },
    getBPFilterClass: function (filter) {
      return this.filter.bpFilter[filter];
    },

    getBPFilterSrc: function (filter) {
      console.log("this.filter", this.filter);
      switch (this.filter.bpFilter[filter]) {
        case "Gray": {
          return "gray";
        }
        case "Green": {
          return "active";
        }
        case "Red": {
          return "inactive";
        }
        case "Yellow": {
          return "orange";
        }
        default: {
          return "gray";
        }
      }
    },
    selectedRow: function (calendarDate) {
      return (
        this.selectedCalendarDateArtist &&
        this.selectedCalendarDateArtist["PRIMARY_KEY"] ==
          calendarDate["PRIMARY_KEY"]
      );
    },
    onBookingDeleted: function (payload) {
      this.makeRequest();
      this[ActionTypes.BookingDetails.DELETE.SINGLE](payload);
    },
    onListScroll(value) {
      this.scrollSubject.next(value);
    },
    onBookingProcessClick() {
      // console.log({ bookingProcessStyle: this.bookingProcessStyle });
      this.bookingProcessStyle =
        this.bookingProcessStyle == "with_icon" ? "with_circle" : "with_icon";
    },
    //MARK: Methods
    openEmailModal: function (emailDetail) {
      // this.emailDetail = emailDetail;
      // openModalRoute(this, "choose_mail_template");
    },
    async fetchListScroll() {
      this.loadingFlag = true;
      await this[ActionTypes.FETCH_BOOKING_ARTIST_LIST_NEXT]();
      this.loadingFlag = false;
    },
    fetchListSearch: async function (searchString) {
      this.loadingFlag = true;
      await this.filterList({
        txt: { key: "txt", value: searchString },
      });
      this.loadingFlag = false;
    },
    filterList: async function (payload) {
      this.loadingFlag = true;
      await this[ActionTypes.UPDATE_FILTER](payload);
      this.loadingFlag = false;
    },
    fetchList: async function () {
      this.loadingFlag = true;
      await this[ActionTypes.FETCH_BOOKING_ARTIST_LIST]();
      this.loadingFlag = false;
    },
    onBookingCheckboxChange(e, item) {},
    onVenueClick: function (item) {
      console.log(item);

      this.$router.push({
        name: bookingVenueRoutes.names.tab,
        params: {
          venue_id: item.booking_location_id,
          tab: "overview",
        },
      });
    },
    exclusivityTooltip: function (artist) {
      // return "HI";
      // console.log('MDSIR Artist - ', artist);
      let tooltipText = "No exclusivity set";
      if (artist.exclusive_icon == 'GREEN') {
        // return artist.exclusivity_json_data;
        const jsonData = JSON.parse(artist.exclusivity_json_data);
        tooltipText = `Exclusivity<br><br>Start Date:&emsp;${jsonData.start_date}<br>End Date:&emsp;&nbsp;&nbsp;${jsonData.end_date}<br>Distance:&emsp;&nbsp;&nbsp;${jsonData.distance} ${jsonData.unit}<br>City:&emsp;&emsp;&emsp;&emsp;${jsonData.city}<br>Country:&emsp;&emsp;${jsonData.country}<br>`;
      } else if (artist.exclusive_icon == 'RED') {
        // return "RED";
        const cJsonData = JSON.parse(artist.exclusivity_conflicts);
        tooltipText = `${this.$t('artist_exclusivity_conflicts_header')}<br><br>` +
          (cJsonData || []).map(b => {
            return `<a class="ut-link ut-text-sm ut-text-accent5" href="#/main/booking/booking_list/${b.calendar_date_id}/overview">
                ${b.booking_date}</a> - ${(b.venue ? b.venue + ': ' : '')}${b.city}, ${b.country}`;
          }).join('<br>');
      }
      return tooltipText;
    },
  },
};

const isValidCalendarDateId = (value) => {
  if (!isNaN(parseInt(value, 10))) {
    if (parseInt(value, 10) > -1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const geti18nMontshDate = (ctx, monthsTV) => {
  return monthsTV.map((e) => {
    if (e.value != "future_dates") {
      return {
        ...e,
        text:
          ctx.$t(e.text?.split(" ")?.[0]?.toLowerCase()) +
          " " +
          e.text?.split(" ")?.[1],
      };
    } else {
      return {
        ...e,
        text: ctx.$t(e.value),
      };
    }
  });
};
</script>

<style lang="scss" scoped>
.dt-page--data-table {
  --offset: 125px;
  // overflow: auto;
  // max-height: calc(100vh - 131px);

  .datatable {
    tbody {
      background: beige;
    }
  }
}

.dt-table {
  --rest-cell-padding: 0px 5px;
  --tb-layout: fixed;
}

/* .booking-table {
  td {
    line-height: 8px;
  }

  td.bookings {
    // color: black !important;
    font-weight: 800 !important;
    &:hover {
      text-decoration: underline;
    }
  }

  td.artist_name:hover {
    font-weight: 900;
    text-decoration: underline;
    // color: black;
  }

  .booking_process {
    img.mail-icon {
      // margin-top: 5px;
    }
  }

  /deep/ table {
    th:nth-child(6),
    td:nth-child(6) {
      width: 370px !important;
      // max-width: 240px !important;
    }
  }
} */
// .bp-filters{
// .dt-icon {
//   &.Gray {
//     // filter: drop-shadow( 0px 0px 5px #ccc) invert(70%) sepia(97%) saturate(1%) hue-rotate(334deg) brightness(96%) contrast(94%);

//   }
//   &.Yellow {
//     // filter: drop-shadow( 0px 0px 5px #ffcc00) invert(76%) sepia(96%) saturate(2614%) hue-rotate(359deg) brightness(102%) contrast(103%);
//     background-color:  #ffcc00;
//   }
//   &.Green {
//     // filter: drop-shadow( 0px 0px 5px #0a0) invert(45%) sepia(75%) saturate(6428%) hue-rotate(113deg) brightness(106%) contrast(108%);
//     background-color:  #0a0;
//   }
//   &.Red {
//     // filter: drop-shadow( 0px 0px 5px #f00) invert(18%) sepia(98%) saturate(7327%) hue-rotate(356deg) brightness(93%) contrast(118%);
//     background-color: #ff6e6e;
//   }
//   // filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(360deg) brightness(0%) contrast(0%);

//   &.Gray {
//     // filter: invert(70%) sepia(97%) saturate(1%) hue-rotate(334deg) brightness(96%) contrast(94%);

//   }
//   &.Yellow {
//     // filter: invert(60%) sepia(38%) saturate(1304%) hue-rotate(1deg) brightness(104%) contrast(103%);
//     //  background-color:  #ffcc00;
//   }
//   &.Green {
//     // filter: invert(45%) sepia(75%) saturate(6428%) hue-rotate(113deg) brightness(106%) contrast(108%);
//     //  background-color:  #0a0;
//   }
//   &.Red {
//     // filter: invert(18%) sepia(98%) saturate(7327%) hue-rotate(356deg) brightness(93%) contrast(118%);
//     // background-color: #f00;
//  }
// }
// }

.dt-calendar {
  min-height: calc(100vh - 130px);
}

// .options-list {
//   div {
//     .list__tile {
//       height: 30px !important;
//       font-size: var(--fs-1);
//     }
//   }
// }
// .list__tile {
//   height: 30px !important;
//   font-size: var(--fs-1);
// }
</style>

<style lang="scss">
.filter-more-options-list {
  .options-item .list__tile {
    height: 30px !important;
    font-size: var(--fs-1);
  }
}

.booking-list,
.booking-calendar {
  .filter-bar-button {
    --bc: transparent;
    margin: 7px 5px !important;
    height: 25px !important;
    padding: 2px 4px !important;
  }

  .top-bar {
    display: flex;
    flex-wrap: wrap;

    .normal-filters {
      flex: 1;

      display: flex;
      margin-left: 15px;
      margin-bottom: 10px;

      color: var(--text-primary);
      flex-wrap: wrap;

      .input-field-container {
        margin-left: 20px;
        margin-right: 20px;
      }

      .add-button {
        flex: 0.015;

        img {
          margin-top: 5px;
        }
      }

      .search {
        flex: 5;
        max-width: 80px;
        margin: 0px 20px;
      }

      .dropdown {
        flex: 5;
        max-width: 127px;
        margin: 0px 10px;

        .dropdown--main {
          border-bottom: 1px solid var(--sprt-5);
        }

        .placeholder {
          // color: var(--sprt-5);
        }
      }

      .month-navigation {
        flex: 0.6 0 40px;
        max-width: 50px;
        padding: 5px;
        margin: 0px 5px 0px 10px;
        display: flex;
      }

      .bl-more-menu {
        flex: 0.5;
      }

      .status-selection-container {
        flex: 5 5 300px;
        display: flex;
        border: 1px solid var(--sprt-6);

        .max-min-button {
          flex: 0.2;
          // margin-top: 5px;
          padding: 5px;
        }

        .status-selection {
          flex: 12;
          display: flex;
          flex-flow: row wrap;

          // height: 200px;
          // font-size: 13px;

          .checkbox {
            flex: 1 0 50%;

            label {
              font-size: var(--font-size);
            }

            .input-group__details {
              display: none;
            }
          }

          .status-item {
            display: flex;
            margin: 5px 0px 5px 5px;

            .status-checkbox {
              padding: 5px 0px 5px 0px;
            }

            .status-text {
              padding: 2px 5px;
            }

            .select-all {
              margin-top: 3px;
              margin-left: 5px;
            }

            .select-all-text {
              margin-top: 2px;
            }
          }
        }
      }

      @media screen and (min-width: 320px) and (max-width: 1440px) {
        // .month-navigation {
        //   flex: 1;
        //   margin: 0 0 0 5px;
        // }
      }

      @media (min-width: 320px) and (max-width: 480px) {
        // flex-direction: column;
        // margin-left: 0px;
        .status-selection-container {
          margin-top: 10px;
        }

        .month-navigation {
          margin: 0px 0px 0px 10px;
          // padding: 5px 0px;
        }
      }
    }

    // .bp-filters-container {
    //   flex: 0.3 0.3;

    //   .bp-filters {
    //     padding-left: 15px;
    //     cursor: pointer;
    //     display: flex;
    //   }

    // }
    @media screen and (min-width: 320px) and (max-width: 480px) {
      flex-direction: column;

      .bp-filters {
        display: flex;
        width: 100%;

        img {
          flex: 1;
        }
      }
    }
  }

  .booking-booking-booking_list {
    --ntable-height: calc(100vh - 135px) !important;
    thead tr {
      border: none !important;
      th {
        border-bottom: 1px solid #ff6400;
      }
    }
    tbody tr {
      border: none !important;
      td {
        border-bottom: 1px solid #ccc;
      }
    }

    tr td.left_options {
      opacity: 0;
      border: none;
      background-color: #fff;
    }
    tr th.left_options {
      opacity: 0;
      border: none;
    }
    tr:hover {
      td.left_options {
        opacity: 1;
      }
    }

    th {
      .sorting-name {
        visibility: hidden;
      }

      &:hover {
        .sorting-name {
          visibility: visible !important;
        }
      }

      .bp-filters {
        img {
          width: 26px;
          height: 26px;
          margin: 2px;
          background-color: #0087FF1A;
          &.status_j{
            background-color: #fff;
          &:hover{
            transition:none;
            border:2px solid #0087FF1A !important;
            background-color: #0087FF1A;
          }
          }
          &:hover{
            transition:none;
            border:2px solid #0087FF1A !important;
          }
        }
        
        .Gray {}

        .Green {
          background: #64c896;
        }

        .Red {
          background: #ff6e6e;
        }

        .Yellow {
          background: #e6dc64;
        }
      }
    }

    th:nth-child(7),
    td:nth-child(7) {
      /* flex: 1.5; */
      /* min-width: 250px; */
    }

    /* th:nth-child(5),
    td:nth-child(5) {
      flex: 0.5;
    } */

    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(7),
      td:nth-child(7) {
        display: none;
      }
    }

    // td.artist_name:hover {
    //   font-weight: 900;
    //   text-decoration: underline;
    //   // color: black;
    // }

    .booking_process {
      display: flex;
       gap:0.3rem;
      img.mail-icon {
        /* margin-top: 5px; */
      }
    }
  }

  .booking_process {
    &.with_icon .stat-ico-container {
      /* height: 15px;
      width: 15px; */
      /* margin: 0px 5.5px; */
      width: 26px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap:0.3rem;

      img {
        width: 25px;
        height: 25px;
      }
    }

    &.with_circle .stat-ico-container {
      height: 15px;
      width: 15px;
      cursor: pointer;
      margin: auto 5.5px;
      border-radius: 30px;
      gap:0.3rem;
      img {
        margin-top: -8px;
        display: none;
      }

      &.filter-icon {
        filter: none;

        img {
          width: 40px;
          height: 40px;

          &:hover {
            filter: none;
          }
        }
      }

      &:not(.filter-icon) {
        &.Gray {
          background: transparent;
        }

        &.Yellow {
          background: #e6dc64;
        }

        &.Green {
          background: #64c896;
        }

        &.Red {
          background: #ff6e6e;
        }
      }

      .status-icon {
      }
    }
  }
}
</style>

<style lang="scss">
.booking-status-cirtext {
  display: flex;
  height: 40px;

  .booking-status-cirtext--circle {
    margin-top: 10px;
    margin-bottom: 10px;

    .circle {
      width: 16px;
      height: 16px;
      border-radius: 50px;
    }
  }

  .booking-status-cirtext--title {
    display: flex;
    flex-direction: column;
    justify-content: center;

    flex: 1;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}
</style>
